/* eslint-disable react/require-default-props */
import React from 'react';

import DynamicDetails from '~/components/Details/DynamicDetails';
import FileDetails from '~/components/Details/FileDetails';
import FixedDetails, { FixedDetail } from '~/components/Details/FixedDetails';
import { ObjectLiteral } from '~/types/generics';

import { Container } from './styles';

export interface ProcessDetailsProps {
  process?: ObjectLiteral;
  loading?: boolean;
  fixedDetails: Array<FixedDetail>;
  numberOfColumns?: number;
}

const ProcessDetails: React.FC<ProcessDetailsProps> = ({
  process,
  loading,
  fixedDetails,
  numberOfColumns = 3,
}: ProcessDetailsProps) => {
  return (
    <Container>
      <FixedDetails
        details={fixedDetails}
        loading={loading}
        columns={numberOfColumns}
      />
      <FileDetails files={process?.files} loading={loading} />
      <DynamicDetails
        variables={process?.variables}
        loading={loading}
        columns={numberOfColumns}
      />
    </Container>
  );
};

export default ProcessDetails;
